export const NEWS_IMAGE_PATH = "/images/news.png";
